<template>
  <div>
    <b-modal
      id="modal-scrollable"
      v-model="$store.state.someVariables.showNewUser"
      scrollable
      no-close-on-backdrop
      title="Agregar Usuario"
      cancel-variant="outline-secondary"
      @hidden="closeModal"
    >
      <b-row>
        <b-col md="12" style="margin-top:1px">
          <v-select
            placeholder="Seleccione Institucion"
            id="selecInstitucion"
            :options="instituciones"
            :clearable="false"
            style="width: 100%"
            @input="changeInstitucion"
            v-model="user.institucionAuxiliar"
          />
          <!-- <v-select
            id="input-instituciones"
            placeholder="Selecciona Institucion"
            :options="instituciones"
            dense
            outlined
            @input="changeInstitucion"
          /> -->
        </b-col>
        <b-col md="12" style="margin-top:20px">
          <div class="form-label-group">
            <b-form-input
              id="nombre-user"
              placeholder="Ingrese Nombre"
              type="text"
              v-model="user.nombre"
              style="text-transform:capitalize"
            />
            <label for="nombre-user">Nombre</label>
          </div>
        </b-col>
        <b-col md="12" style="margin-top:6px">
          <div class="form-label-group">
            <b-form-input
              id="apellido-user"
              placeholder="Ingrese Apellido"
              type="text"
              v-model="user.apellido"
              style="text-transform:capitalize"
            />
            <label for="floating-apellido">Apellido</label>
          </div>
        </b-col>
        <b-col md="12" style="margin-top:6px">
          <div class="form-label-group">
            <b-form-input
              id="email-user"
              placeholder="Ingrese Email"
              type="text"
              v-model="user.email"
            />
            <label for="email-user">Email</label>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <span><b>Seleccione Rol</b></span>
          <div class="demo-inline-spacing">
            <b-form-radio
              v-if="
                USER().rol == `${ROLES.SUPER}` ||
                  USER().rol == `${ROLES.ADMIN}` ||
                  USER().rol == `${ROLES.CALIFICACION}`
              "
              v-model="user.rol"
              name="radio-rol"
              value="club"
              class="mt-1"
            >
              Club
            </b-form-radio>
            <b-form-radio
              v-if="
                USER().rol == `${ROLES.SUPER}` || USER().rol == `${ROLES.ADMIN}`
              "
              v-model="user.rol"
              name="radio-rol"
              value="calificacion"
              class="mt-1"
            >
              Comisión Calificación
            </b-form-radio>
            <b-form-radio
              v-if="
                USER().rol == `${ROLES.SUPER}` || USER().rol == `${ROLES.ADMIN}`
              "
              v-model="user.rol"
              name="radio-rol"
              value="tecnica"
              class="mt-1"
            >
              Comisión Técnica
            </b-form-radio>
            <b-form-radio
              v-if="
                USER().rol == `${ROLES.SUPER}` || USER().rol == `${ROLES.ADMIN}`
              "
              v-model="user.rol"
              name="radio-rol"
              value="sanciones"
              class="mt-1"
            >
              Comisión Penas y Sanciones
            </b-form-radio>
            <b-form-radio
              v-if="
                USER().rol == `${ROLES.SUPER}` || USER().rol == `${ROLES.ADMIN}`
              "
              v-model="user.rol"
              name="radio-rol"
              value="tesoreria"
              class="mt-1"
            >
              Tesoreria
            </b-form-radio>
            <b-form-radio
              v-if="
                USER().rol == `${ROLES.SUPER}` || USER().rol == `${ROLES.ADMIN}`
              "
              v-model="user.rol"
              name="radio-rol"
              value="admin"
              class="mt-1"
            >
              Administrador
            </b-form-radio>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="user.rol == 'club'">
        <b-col md="12" class="mt-2">
          <span><b>Selecciona los equipos que puede editar el Usuario</b></span>
          <b-form-checkbox
            v-for="item in user.listTeamsEdit"
            :key="item.id"
            v-model="item.seleccionado"
            style="display:block"
            class="mt-2 text-capitalize"
          >
            {{ item.disciplina }} {{ item.categoria }} {{ item.equipo }}
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row
        v-if="
          user.rol === `${ROLES.ADMIN}` || user.rol === `${ROLES.CALIFICACION}`
        "
      >
        <b-col md="12" class="mt-2">
          <span><b>Permisos del usuario</b></span>
          <b-form-checkbox
            style="display:block"
            class="mt-2 text-capitalize"
            v-model="user.permissionPlayer"
          >
            Permitir edicion de jugadores antiguos
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row
        v-if="USER().rol == `${ROLES.SUPER}` || USER().rol == `${ROLES.ADMIN}`"
      >
        <b-col md="12" class="mt-2">
          <span><b>Permisos de auditoria</b></span>
          <b-form-checkbox
            style="display:block"
            class="mt-2"
            v-model="user.permissionAuditoria"
          >
            Permitir ingreso a sección auditoria
          </b-form-checkbox>
        </b-col>
      </b-row>
      <template #modal-footer>
        <div class="w-100">
          <template v-if="!showLoading">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="float-right"
              @click="saveUser"
            >
              Guardar
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              class="float-right mr-1"
              @click="onlyClose"
            >
              Cancelar
            </b-button>
          </template>
          <div v-if="showLoading" class="text-center mt-1">
            <b-spinner variant="primary" label="Text Centered" />
          </div>
          <b-alert
            :show="dismissCountDown"
            v-height-fade.appear
            :variant="variante"
            style="position:absolute; bottom:55px;  width:92%; margin-left:-4px; z-index:1000"
            @dismiss-count-down="countDownChanged"
          >
            <div
              :class="{
                'alert-body danger': variante == 'danger',
                'alert-body success': variante == 'success',
              }"
            >
              {{ messageError }}
            </div>
          </b-alert>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'

import {
  BModal,
  BRow,
  BCol,
  BFormInput,
  BFormRadio,
  // BFormCheckboxGroup,
  BFormCheckbox,
  //   BFormTextarea,
  //   BFormGroup,
  //   BFormRadioGroup,
  //   BInputGroupPrepend,
  //   BInputGroup,
  //   BFormCheckbox,
  BAlert,
  BButton,
  BSpinner,
  //   VBPopover,
  //   BAvatar,
  //   BPopover,
  //   BForm,
  //   BInputGroup,
  //   BInputGroupPrepend,
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import store from '@/store'
// import useUsers from './useUsers'
import apiCall from '../../utils/apiCall'
import { URL, ROLES, USER } from '../../utils/variables'

export default {
  components: {
    BModal,
    BRow,
    BCol,
    vSelect,
    BFormInput,
    BFormRadio,
    // BFormCheckboxGroup,
    BFormCheckbox,
    BButton,
    BAlert,
    BSpinner,
  },
  directives: {
    // 'b-popover': VBPopover,
    heightFade,
    Ripple,
  },
  props: {
    instituciones: Array,
    user: Object,
    action: String,
  },
  setup(props, { emit }) {
    // const radioRol = ref('')
    const checkTeams = ref([])
    const showLoading = ref(false)
    const hasError = ref(false)
    const messageError = ref('')
    const dismissCountDown = ref(0)
    const dismissSecs = ref(3)
    const variante = ref('danger')
    const { getApi, postApi } = apiCall()
    // const listTeamsEdit = ref([])
    // watch(radioRol, value => {
    //   if (value === 'club') {

    //   }
    //   console.log(despues)
    // })
    async function getEquiposEditar(idInstitucion) {
      props.user.listTeamsEdit = []
      const path = `ApiUsuario/getTodosEquiposParaUsuario/${idInstitucion}`
      const data = await getApi(URL, path)
      if (data.flag === 's') {
        props.user.listTeamsEdit = data.data
        props.user.listTeamsEdit.forEach(element => {
          element.seleccionado = false
        })
      } else {
        props.user.listTeamsEdit = []
      }
      // console.log(props.user)
    }
    function changeInstitucion(item) {
      // console.log(item)
      getEquiposEditar(item.value)
      props.user.id_institucion = item.value
      props.user.rol = null
    }
    function countDownChanged(dismissCountDownAux) {
      dismissCountDown.value = dismissCountDownAux
    }
    function initUser() {
      props.user.nombre = ''
      props.user.apellido = ''
      props.user.email = ''
      props.user.rol = null
      props.user.listTeamsEdit = []
      props.user.institucionAuxiliar = null
      props.user.id_institucion = ''
      hasError.value = false
      props.user.permissionPlayer = false
      props.user.permissionAuditoria = false
      // props.user.institucionAuxiliar.label = 'Seleccione institucion'
    }
    function closeModal(bvModalEvt) {
      bvModalEvt.preventDefault()
      // initUser()
      store.commit('someVariables/UPDATE_SHOW_NEW_USER', false)
      countDownChanged(0)
      // emit('recargar')
      //   console.log('hidden')
      //   hasError.value = false
    }
    function onlyClose() {
      store.commit('someVariables/UPDATE_SHOW_NEW_USER', false)
    }
    function focusInput(id, error) {
      document.getElementById(id).focus()
      messageError.value = error
    }
    function validarEmail(email) {
      // eslint-disable-next-line
      const expr = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
      let vale = false
      if (!expr.test(email)) {
        vale = false
      } else {
        vale = true
      }
      return vale
    }
    function hasErrorForm() {
      // console.log(refCi)
      // console.log(props.user)
      let error = false
      if (
        props.user.id_institucion === '' ||
        props.user.id_institucion === null ||
        props.user.id_institucion === undefined
      ) {
        focusInput('selecInstitucion', 'Elija una institución')
        error = true
      } else if (
        props.user.nombre === '' ||
        props.user.nombre === null ||
        props.user.nombre === undefined
      ) {
        focusInput('nombre-user', 'Nombre es requerido')
        error = true
      } else if (
        props.user.apellido === '' ||
        props.user.apellido === null ||
        props.user.apellido === undefined
      ) {
        focusInput('apellido-user', 'Apellidos es requerido')
        error = true
      } else if (
        props.user.email === '' ||
        props.user.email === null ||
        props.user.email === undefined
      ) {
        focusInput('email-user', 'Email es requerido')
        error = true
      } else if (!validarEmail(props.user.email)) {
        focusInput(
          'email-user',
          // eslint-disable-next-line
          'Email debe ser de la forma ejm: xyz@hotmail.com'
        )
        error = true
      } else if (
        props.user.rol === '' ||
        props.user.rol === null ||
        props.user.rol === undefined
      ) {
        messageError.value = 'Seleccione un rol de usuario'
        error = true
      } else {
        error = false
      }
      return error
    }
    function verifyRol(rol, cadenaEquipos) {
      // console.log(rol, cadenaEquipos)
      let verificado = false
      if (rol === 'club' && cadenaEquipos === '') {
        verificado = false
      } else if (rol === 'club' && cadenaEquipos !== '') {
        verificado = true
      } else if (rol !== 'club') {
        verificado = true
      }
      return verificado
    }
    function showMessageAlert(type, mensaje) {
      variante.value = type
      hasError.value = true
      messageError.value = mensaje
      dismissCountDown.value = dismissSecs.value
    }
    function arrayIdEquiposToString() {
      let stringEquipos = ''
      if (props.user.rol === 'club') {
        props.user.listTeamsEdit.forEach(element => {
          if (element.seleccionado) stringEquipos += `${element.id_equipo},`
        })
      }
      return stringEquipos
    }

    async function saveUser() {
      props.user.action = props.action
      hasError.value = hasErrorForm()
      if (!hasError.value) {
        showLoading.value = true
        props.user.cadenaEquipos = arrayIdEquiposToString()
        const verificado = verifyRol(props.user.rol, props.user.cadenaEquipos)
        if (verificado) {
          const path = 'ApiUsuario/crearUsuario'
          const response = await postApi(URL, path, props.user)
          if (response.flag === 'si') {
            if (props.action === 'insert') {
              showMessageAlert('success', 'USUARIO creado exitosamente')
              initUser()
              emit('recargar', response.info)
            } else {
              // showMessageAlert('success', 'USUARIO actualizado exitosamente')
              // initUser()
              store.commit('someVariables/UPDATE_SHOW_NEW_USER', false)
              emit('recargarUpdate', response.info)

              // emit('recargar')
            }
            //   initPlayer()
          } else {
            showMessageAlert('danger', response.mensaje)
          }
          showLoading.value = false
        } else {
          messageError.value = 'Debe elegir almenos un equipo'
          variante.value = 'danger'
          dismissCountDown.value = dismissSecs.value
          showLoading.value = false
        }
      } else {
        variante.value = 'danger'
        dismissCountDown.value = dismissSecs.value
      }
      //   console.log(hasError.value)
      // console.log()
    }

    return {
      closeModal,
      changeInstitucion,
      // listTeamsEdit,
      //   radioRol,
      checkTeams,
      showLoading,
      messageError,
      dismissSecs,
      countDownChanged,
      dismissCountDown,
      saveUser,
      variante,
      hasError,
      ROLES,
      USER,
      onlyClose,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.danger {
  background-color: #ea5454c7;
  border-radius: 5px;
  color: white;
}
.success {
  background-color: #10860c;
  border-radius: 5px;
  color: white;
}
</style>
